var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.986,
    height: 21.528,
    viewBox: "0 0 18.986 14.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2701",
    "data-name": "Rectangle 2701",
    width: 18.986,
    height: 14.528,
    fill: "#05a405"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4615",
    "data-name": "Group 4615",
    transform: "translate(-1285.523 -20.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4548",
    "data-name": "Group 4548",
    transform: "translate(1285.523 20.5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M225.408,306.939h0a1.038,1.038,0,0,1-1.327.123,6.024,6.024,0,0,0-7.126,0,1.039,1.039,0,1,1-1.172-1.717,8.3,8.3,0,0,1,9.469,0,1.039,1.039,0,0,1,.156,1.594",
    transform: "translate(-211.025 -297.793)",
    fill: "#05a405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M121.688,155.024h0a.993.993,0,0,1-1.306.09,9.291,9.291,0,0,0-11.513,0,.993.993,0,0,1-1.219-1.567,11.1,11.1,0,0,1,13.951,0,.994.994,0,0,1,.087,1.477",
    transform: "translate(-105.133 -148.065)",
    fill: "#05a405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M18.705,4.794,18.7,4.8a.964.964,0,0,1-1.3.059,12.343,12.343,0,0,0-15.805,0A.964.964,0,0,1,.288,4.8L.279,4.794a.963.963,0,0,1,.05-1.4,14.08,14.08,0,0,1,18.326,0,.963.963,0,0,1,.05,1.4",
    transform: "translate(0)",
    fill: "#05a405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M333.037,458.922h0a1.031,1.031,0,0,1-1.209.193,2.994,2.994,0,0,0-2.887,0,1.038,1.038,0,0,1-.969-1.836,4.884,4.884,0,0,1,4.825,0,1.038,1.038,0,0,1,.239,1.643",
    transform: "translate(-320.892 -447.522)",
    fill: "#05a405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M419.9,613.121a1.153,1.153,0,1,1-1.153-1.153,1.153,1.153,0,0,1,1.153,1.153",
    transform: "translate(-409.255 -599.746)",
    fill: "#05a405"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGood);
export default __webpack_public_path__ + "static/media/good.302424b4.svg";
export { ForwardRef as ReactComponent };